/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import {
  PieChart, Pie, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';
import PropTypes from 'prop-types';
import Icon from '@mdi/react';
import { mdiDownloadOutline } from '@mdi/js';
import Panel from '../../../shared/components/Panel';
import { getPercentage } from '../../../shared/utils';

class CasesStatisticsComponet extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {}

  render() {
    const { body, onClickExport } = this.props;

    const tipo = [
      {
        name: 'Consulta',
        value: body.types ? body.types.query : 0,
        fill: '#4ce1b6',
      },
      {
        name: 'Solicitud',
        value: body.types ? body.types.request : 0,
        fill: '#70bbfd',
      },
      {
        name: 'Reclamo',
        value: body.types ? body.types.claim : 0,
        fill: '#ff4861',
      },
    ];

    const estado = [
      {
        name: 'Abierto',
        value: body.status ? body.status.opened : 0,
        fill: '#4ce1b6',
      },
      {
        name: 'Reabierto',
        value: body.status ? body.status.re_opened : 0,
        fill: '#f6da6e',
      },
      {
        name: 'Cerrado',
        value: body.status ? body.status.closed : 0,
        fill: '#70bbfd',
      },
      {
        name: 'Pendiente',
        value: body.status ? body.status.pending : 0,
        fill: '#ff4861',
      },
    ];

    const plazo = [
      {
        name: 'Dentro plazo',
        value: body.deadlines ? body.deadlines.withinTerm : 0,
        fill: '#4ce1b6',
      },
      {
        name: 'Fuera plazo',
        value: body.deadlines ? body.deadlines.OutTerm : 0,
        fill: '#ff4861',
      },
    ];

    const origen = [
      {
        name: 'Correo',
        value: body.origins ? body.origins.email : 0,
        fill: '#fab35b',
      },
      {
        name: 'Presencial',
        value: body.origins ? body.origins.face : 0,
        fill: '#4ce1b6',
      },
      {
        name: 'Referido',
        value: body.origins ? body.origins.referred : 0,
        fill: '#70bbfd',
      },
      {
        name: 'Teléfono',
        value: body.origins ? body.origins.phone : 0,
        fill: '#f6da6e',
      },
      {
        name: 'Web',
        value: body.origins ? body.origins.web : 0,
        fill: '#d959d2',
      },
    ];

    const style = {
      left: 0,
      width: 150,
      lineHeight: '24px',
      position: 'relative',
    };

    const renderLegend = ({ payload }) => (
      <ul className="dashboard__chart-legend">
        {
          payload.map((entry, index) => {
            let { total } = body;
            if (entry.value === 'Fuera plazo' || entry.value === 'Dentro plazo') {
              total = plazo[0].value + plazo[1].value;
            }
            return (
              <li key={`item-${index}`}>
                <span style={{ backgroundColor: entry.color }} />
                {entry.value}: {entry.payload.value} ({getPercentage(entry.payload.value, total)}%)
              </li>
            );
          })
        }
      </ul>
    );

    renderLegend.propTypes = {
      payload: PropTypes.arrayOf(PropTypes.shape({
        color: PropTypes.string,
        value: PropTypes.string,
      })).isRequired,
    };

    const renderTooltip = ({ active, payload }) => {
      if (active) {
        return (
          <div className="recharts-custom-tooltip">
            <p className="label">{`${payload[0].name}: ${payload[0].value} (${getPercentage(payload[0].value, this.props.body.total)}%)`}</p>
          </div>
        );
      }
      return null;
    };

    return (
      <div className="section-content row">
        <Panel
          lg={6}
          md={6}
          xl={3}
          title="TIPOS CASOS"
          subhead="Total"
        >
          <div className="dashboard__visitors-chart">
            <h1 className="dashboard__visitors-chart-title">{ body.total ? body.total : 0 }</h1>
            <ResponsiveContainer className="dashboard__chart-pie" width="100%" height={220}>
              <PieChart className="dashboard__chart-pie-container">
                <Tooltip content={renderTooltip} />
                <Pie data={tipo} dataKey="value" cy={110} cx={95} innerRadius={70} outerRadius={100} />
                <Legend layout="vertical" verticalAlign="bottom" wrapperStyle={style} content={renderLegend} />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="panel-actions">
            <button className="button-icon-light small" type="button" title="Exportar" onClick={() => onClickExport('type')}>
              <Icon path={mdiDownloadOutline} size="15px" />
            </button>
          </div>
        </Panel>
        <Panel
          lg={6}
          md={6}
          xl={3}
          title="ESTADO"
          subhead="Total"
        >
          <div className="dashboard__visitors-chart">
            <h1 className="dashboard__visitors-chart-title">{ body.total ? body.total : 0 }</h1>
            {/* <p className="dashboard__visitors-chart-number">12,384</p> */}
            <ResponsiveContainer className="dashboard__chart-pie" width="100%" height={220}>
              <PieChart className="dashboard__chart-pie-container">
                <Tooltip content={renderTooltip} />
                <Pie data={estado} dataKey="value" cy={110} cx={95} innerRadius={70} outerRadius={100} />
                <Legend layout="vertical" verticalAlign="bottom" wrapperStyle={style} content={renderLegend} />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="panel-actions">
            <button className="button-icon-light small" type="button" title="Exportar" onClick={() => onClickExport('status')}>
              <Icon path={mdiDownloadOutline} size="15px" />
            </button>
          </div>
        </Panel>
        <Panel
          lg={6}
          md={6}
          xl={3}
          title="PLAZO"
          subhead="Total"
        >
          <div className="dashboard__visitors-chart">
            <h1 className="dashboard__visitors-chart-title">{ body.deadlines ? (body.deadlines.withinTerm + body.deadlines.OutTerm) : 0 }</h1>
            {/* <p className="dashboard__visitors-chart-number">12,384</p> */}
            <ResponsiveContainer className="dashboard__chart-pie" width="100%" height={220}>
              <PieChart className="dashboard__chart-pie-container">
                <Tooltip content={renderTooltip} />
                <Pie data={plazo} dataKey="value" cy={110} cx={95} innerRadius={70} outerRadius={100} />
                <Legend layout="vertical" verticalAlign="bottom" wrapperStyle={style} content={renderLegend} />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="panel-actions">
            <button className="button-icon-light small" type="button" title="Exportar" onClick={() => onClickExport('deadlines')}>
              <Icon path={mdiDownloadOutline} size="15px" />
            </button>
          </div>
        </Panel>
        <Panel
          lg={6}
          md={6}
          xl={3}
          title="ORIGEN"
          subhead="Total"
        >
          <div className="dashboard__visitors-chart">
            <h1 className="dashboard__visitors-chart-title">{ body.total ? body.total : 0 }</h1>
            {/* <p className="dashboard__visitors-chart-number">12,384</p> */}
            <ResponsiveContainer className="dashboard__chart-pie" width="100%" height={220}>
              <PieChart className="dashboard__chart-pie-container">
                <Tooltip content={renderTooltip} />
                <Pie data={origen} dataKey="value" cy={110} cx={95} innerRadius={70} outerRadius={100} />
                <Legend layout="vertical" verticalAlign="bottom" wrapperStyle={style} content={renderLegend} />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="panel-actions">
            <button className="button-icon-light small" type="button" title="Exportar" onClick={() => onClickExport('origins')}>
              <Icon path={mdiDownloadOutline} size="15px" />
            </button>
          </div>
        </Panel>
      </div>
    );
  }
}

export default CasesStatisticsComponet;
